// import axios from "axios";
// import React, { useEffect, useState } from "react";
// import { Col, Container, Row, Button, Card } from "react-bootstrap";
// import { Link } from "react-router-dom";
// import DeletePlan from "../Modal/DeletePlan";
// import AddPlan from "../Modal/AddPlan";
// import EditPlan from "../Modal/EditPlan";
// import { useTranslation } from "react-i18next";

// const PlansList = () => {
//   const [plans, setPlans] = useState([]);  
//   const {t} = useTranslation();
//   const [editPlanId, setEditPlanId] = useState('');
//   const[deleteModalShow,setDeleteModalShow]=useState(false);
//   const[editModalShow,setEditModalShow]=useState(false);
//   const[planId,setPlanId]=useState();
//   const API_URL = process.env.REACT_APP_API_URL;
//   const API_VERSION = process.env.REACT_APP_API_VERSION;
//   const [addModal,setAddModal] = useState(false);

//   async function getPlans() {
//     await axios
//       .get(`${API_URL}/${API_VERSION}/plan`, {
//         headers: {
//           accept: "application/json",
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//         },
//       })
//       .then((response) => {
//         setPlans(response.data);
//       })
//       .catch((error) => {});
//   }

//   function planDelete(id){
//     setPlanId(id)
//     setDeleteModalShow(true);

//   }

//   useEffect(() => {
//     getPlans();
//   },);

//   return (
//     <>
//       <section className="clients_main">
//         <Container fluid>
//           <Row>
//             <Col md={12}>
//               <Card>
//                 <Card.Header as="h5">
//                   <div className="d-flex align-items-center justify-content-between gap-3">
//                     <div className="head_title">
//                       <h3 className="mb-0">{t("Plans")}</h3>
//                     </div>
//                     <Link className="button" onClick={()=>setAddModal(true)}>
//                       <i className="fa-solid fa-circle-plus"></i> Add Plan
//                     </Link>
//                   </div>
//                 </Card.Header>
//                 <Card.Body>
//                   <table className="client_table">
//                     <thead>
//                       <tr className="d-none d-lg-table-row">
//                         <th width="5%">{t("Position")}</th>
//                         <th width="11%">{t("Title")}</th>
//                         <th width="12%">{t("Prices")}</th>
//                         <th width="11%">{t("Frequency")}</th>
//                         <th width="11%">{t("Bot")}</th>
//                         <th width="11%">{t("Questions")}</th>
//                         <th width="11%">{t("Scan URL")}</th>
//                         <th width="11%">{t("Storage Size")}</th>
//                         <th width="11%">{t("Action")}</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {plans &&
//                         plans.map((plan, index) => (
//                           <tr className="tr" key={index}>
//                             <td>
//                               <strong className="ht">{t("Position")} : </strong>
//                               <p>{plan.position}</p>
//                             </td>
//                             <td>
//                               <strong className="ht">{t("Title")} : </strong>
//                               <p>{plan.name}</p>
//                             </td>
//                             <td>
//                               <strong className="ht">{t("Prices")} : </strong>
//                               <p>{plan.price}</p>
//                             </td>
//                             <td>
//                               <strong className="ht">{t("frequency")} : </strong>
//                               <p>{plan.duration}</p>
//                             </td>
//                             <td>
//                               <strong className="ht">{t("Bot")} : </strong>
//                               <p>{plan.maxBot}</p>
//                             </td>
//                             <td>
//                               <strong className="ht">{t("Questions")} : </strong>
//                               <p>{plan.maxMessage}</p>
//                             </td>
//                             <td>
//                               <strong className="ht">{t("Scan URL")} : </strong>
//                               <p>{plan.maxUrlCount}</p>
//                             </td>
//                             <td>
//                               <strong className="ht">{t("Storage Size")} : </strong>
//                               <p>{plan.storage} MB</p>
//                             </td>
//                             <td>
//                               <strong className="ht">{t("Action")} : </strong>
//                               <p className="d-flex gap-2">
//                                 <Link
//                                   className="button"
//                                   onClick={()=>{setEditModalShow(true)
//                                   setEditPlanId(plan.id)}}
//                                 >
//                                   <i className="fa-solid fa-pen-to-square"></i>
//                                 </Link>
//                                 <Button className="color_orange" variant="" onClick={()=>planDelete(plan.id)}>
//                                   <i className="fa-solid fa-trash-can"></i>
//                                 </Button>
//                               </p>
//                             </td>
//                           </tr>
//                         ))}
//                     </tbody>
//                   </table>
//                 </Card.Body>
//               </Card>
//             </Col>
//           </Row>
//         </Container>
//       </section>
//       <DeletePlan
//       show={deleteModalShow}
//       getPlanId={planId}
//       getplans={getPlans}
//       onHide={() => setDeleteModalShow(false)}
//       />
//       <AddPlan
//       show={addModal}
//       getplans={getPlans}
//       onHide={() =>setAddModal(false)}
//       />
//        <EditPlan
//       show={editModalShow}
//       id={editPlanId}
//       getplans={getPlans}
//       onHide={() => setEditModalShow(false)}
//       />
//     </>
//   );
// };

// export default PlansList;
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Col, Container, Row, Button, Card, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import DeletePlan from "../Modal/DeletePlan";
import AddPlan from "../Modal/AddPlan";
import EditPlan from "../Modal/EditPlan";
import { useTranslation } from "react-i18next";

const PlansList = () => {
  const [plans, setPlans] = useState([]);  
  const {t} = useTranslation();
  const [editPlanId, setEditPlanId] = useState('');
  const[deleteModalShow,setDeleteModalShow]=useState(false);
  const[editModalShow,setEditModalShow]=useState(false);
  const[planId,setPlanId]=useState();
  const API_URL = process.env.REACT_APP_API_URL;
  const API_VERSION = process.env.REACT_APP_API_VERSION;
  const [addModal,setAddModal] = useState(false);
  const [, setStatus] = useState();

  
  async function getPlans() {
    let id=localStorage.getItem('id')
    await axios
      .get(`${API_URL}/${API_VERSION}/plan/user/${id}`, {
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        setPlans(response.data);
      })
      .catch((error) => {});
  }

  function planDelete(id){
    setPlanId(id)
    setDeleteModalShow(true);

  }

  function updatePlan(e,id) {
    const newIsActive = e.target.checked;
    axios
      .get(`${API_URL}/${API_VERSION}/planStatus/${id}`, {
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        setStatus(response.data.status);
      })
      .catch((error) => {
        console.log("Plan status : ",error);
      });
    setStatus(newIsActive);
    axios
      .patch(`${API_URL}/${API_VERSION}/planStatus/${id}`,{
          newIsActive,
        },
        {
          headers: {
            accept: "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      )
      .then((response) => {
        setStatus(newIsActive);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  useEffect(() => {
    getPlans();
  },[]);

  return (
    <>
      <section className="clients_main">
        <Container fluid>
          <Row>
            <Col md={12}>
              <Card>
                <Card.Header as="h5">
                  <div className="d-flex align-items-center justify-content-between gap-3">
                    <div className="head_title">
                      <h3 className="mb-0">{t("Plans")}</h3>
                    </div>
                    <Link className="button" onClick={()=>setAddModal(true)}>
                      <i className="fa-solid fa-circle-plus"></i> {t("Add Plan")}
                    </Link>
                  </div>
                </Card.Header>
                <Card.Body>
                  <table className="client_table">
                    <thead>
                      <tr className="d-none d-lg-table-row">
                        <th width="5%">{t("Position")}</th>
                        <th width="11%">{t("Title")}</th>
                        <th width="12%">{t("Prices")}</th>
                        <th width="11%">{t("Frequency")}</th>
                        <th width="11%">{t("Bot")}</th>
                        <th width="11%">{t("Questions")}</th>
                        <th width="11%">{t("Scan URL")}</th>
                        <th width="11%">{t("Storage Size")}</th>
                        <th width="11%">{t("Action")}</th>
                        <th width="11%">{t("Status")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {plans &&
                        plans.map((plan, index) => (
                          <tr className="tr" key={index}>
                            <td>
                              <strong className="ht">{t("Position")} : </strong>
                              <p>{plan.position}</p>
                            </td>
                            <td>
                              <strong className="ht">{t("Title")} : </strong>
                              <p>{plan.name}</p>
                            </td>
                            <td>
                              <strong className="ht">{t("Prices")} : </strong>
                              <p>{plan.price}</p>
                            </td>
                            <td>
                              <strong className="ht">{t("frequency")} : </strong>
                              <p>{plan.duration === "month" ? "Monthly" : "Yearly" }</p>
                            </td>
                            <td>
                              <strong className="ht">{t("Bot")} : </strong>
                              <p>{plan.maxBot}</p>
                            </td>
                            <td>
                              <strong className="ht">{t("Questions")} : </strong>
                              <p>{plan.maxMessage}</p>
                            </td>
                            <td>
                              <strong className="ht">{t("Scan URL")} : </strong>
                              <p>{plan.maxUrlCount}</p>
                            </td>
                            <td>
                              <strong className="ht">{t("Storage Size")} : </strong>
                              <p>{plan.storage} MB</p>
                            </td>
                            <td>
                              <strong className="ht">{t("Action")} : </strong>
                              <p className="d-flex gap-2">
                                <Link
                                  className="button"
                                  onClick={()=>{setEditModalShow(true)
                                  setEditPlanId(plan.id)}}
                                >
                                  <i className="fa-solid fa-pen-to-square"></i>
                                </Link>
                                <Button className="color_orange" variant="" onClick={()=>planDelete(plan.id)}>
                                  <i className="fa-solid fa-trash-can"></i>
                                </Button>
                              </p>
                            </td>
                            <td>
                              <strong className="ht">{t("Status")} : </strong>
                              <p className="d-flex gap-2">
                              <Form>
                                <Form.Check
                                  type="switch"
                                  id={plan.id}
                                  defaultChecked={plan.status}
                                  onChange={(e) => updatePlan(e, plan.id)}
                                />
                              </Form>
                              </p>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
      <DeletePlan
      show={deleteModalShow}
      getPlanId={planId}
      getplans={getPlans}
      onHide={() => setDeleteModalShow(false)}
      />
      
      <AddPlan
      show={addModal}
      getplans={getPlans}
      onHide={() =>setAddModal(false)}
      />

      <EditPlan
      show={editModalShow}
      id={editPlanId}
      getplans={getPlans}
      onHide={() => setEditModalShow(false)}
      />
    </>
  );
};

export default PlansList;
